module.exports = __webpack_public_path__ + "assets/synchronize.201787cfd9b1a52275407afcdc8217eb.svg";


//////////////////
// WEBPACK FOOTER
// ./img/synchronize.svg
// module id = 1020
// module chunks = 0